'use client'

import { SolidButton } from '@macarongfactory/web-ui'
import { useRouter } from 'next/navigation'

import { IconAlertCircle } from '@/shared/assets'
import { Result } from '@/shared/ui'

export default function NotFound() {
  const router = useRouter()
  return (
    <div className='flex h-screen items-center justify-center'>
      <Result
        title='페이지를 찾을 수 없어요'
        description={'입력한 주소가 정확하지 \n 다시 한번 확인해주세요'}
        icon={
          <IconAlertCircle
            width={56}
            height={56}
            className='text-foreground-neutral-muted'
          />
        }
        button={
          <SolidButton
            size='medium'
            text='이전 화면으로'
            variant='neutral-weak'
            clickable={() => router.back()}
          />
        }
      />
    </div>
  )
}
